
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wenn der Magen bei Migräne streikt, wird auch der Wirkstoff in einer Tablette
oder Kapsel kaum noch aufgenommen. Tropfen, Brausetabletten, Nasenspray oder
Zäpfchen funktionieren in dieser Situation besser. Wer ein Anti-Brechmittel
gegen die Übelkeit braucht, sollte es 15 Minuten vor dem Schmerzmittel nehmen –
falls er nicht sowieso auf eine andere Darreichungsform ausweicht. Ebenfalls
wichtig zu wissen: Eine Migräne kann manchmal länger dauern als die Wirkung des
Schmerzmedikamentes anhält. Sobald diese nachlässt, kehren die Schmerzen wieder
zurück. Bei den Triptanen zum Beispiel tritt dieser «Wiederkehrkopfschmerz» in
15 bis 40 Prozent der Fälle auf. Und der letzte, wichtige Punkt: Medikamente an
maximal 10 Tagen pro Monat einnehmen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;